if (document.getElementById('page-company-offices')) {
  const content = document.querySelector('.companyOffices__navContent')
  const lists = document.querySelector('.companyOffices__lists')
  const listAll = document.querySelectorAll('.companyOffices__list')
  const pinAll = document.querySelectorAll('.companyOffices__pin')

  /**
   * リストとピンのクラスを切り替える
   *
   * @param {integer} id        [data-id]の番号
   * @param {string} className  追加・削除するクラス名
   * @param {boolean} isAdd     trueなら追加、falseなら削除
   * @param {boolean} isListAdjust trueならhoverクラスが付与されているリストを画面内にスクロール（表示）
   */
  function toggleClass(id, className, isAdd, isListAdjust = false) {
    // リストの切り替え
    listAll.forEach((list) => {
      if (id < 0 || list.dataset.id == id) {
        if (isAdd) {
          list.classList.add(className)
        } else {
          list.classList.remove(className)
        }
      }
    })

    // ピンの切り替え
    pinAll.forEach((pin) => {
      if (id < 0 || pin.dataset.id == id) {
        if (isAdd) {
          pin.classList.add(className)
        } else {
          pin.classList.remove(className)
        }
      }
    })

    const hoverList = lists.querySelector('.hover')
    if (isListAdjust && hoverList) {
      const rectContent = content.getBoundingClientRect()
      const rectList = hoverList.getBoundingClientRect()

      const posCurrent = rectList.top - rectContent.top
      content.scrollBy({
        top: posCurrent,
        left: 0,
        behavior: 'smooth',
      })
    }
  }

  /**
   * リスト関連の処理
   */
  listAll.forEach((list) => {
    /**
     * リストがマウスオーバー/アウトされた時の処理
     */
    list.addEventListener('mouseover', (e) => {
      toggleClass(list.dataset.id, 'hover', true)
    })

    list.addEventListener('mouseout', (e) => {
      toggleClass(list.dataset.id, 'hover', false)
    })

    /**
     * リストがクリックされた時の処理
     */
    list.addEventListener('click', (e) => {
      if (e.target.classList.contains('companyOffices__list')) {
        if (!list.classList.contains('active')) {
          toggleClass(-1, 'active', false)
          toggleClass(list.dataset.id, 'active', true)
        } else {
          toggleClass(list.dataset.id, 'active', false)
        }
      }
    })

    /**
     * モーダルの閉じるボタンがクリックされた時の処理
     */
    const modalClose = list.querySelector('.companyOffices__modalClose')
    modalClose.addEventListener('click', () => {
      toggleClass(-1, 'active', false)
    })
  })

  /**
   * ピン関連の処理
   */
  pinAll.forEach((pin) => {
    /**
     * ピンがマウスオーバー/アウトされた時の処理
     */
    pin.addEventListener('mouseover', (e) => {
      toggleClass(pin.dataset.id, 'hover', true, true)
    })

    pin.addEventListener('mouseout', (e) => {
      toggleClass(pin.dataset.id, 'hover', false)
    })

    /**
     * ピンがクリックされた時の処理
     */
    pin.addEventListener('click', (e) => {
      if (!pin.classList.contains('active')) {
        toggleClass(-1, 'active', false)
        toggleClass(pin.dataset.id, 'active', true)
      } else {
        toggleClass(pin.dataset.id, 'active', false)
      }
    })
  })

  /**
   * スクロールバー関連の処理
   */
  const scrollbar = document.querySelector('.companyOffices__scrollbarThumb')
  const adjustScrollbar = () => {
    const top = (content.scrollTop / lists.clientHeight) * 100 // %
    const height = (content.clientHeight / lists.clientHeight) * 100 // %

    scrollbar.style.top = `${top}%`
    scrollbar.style.height = `${height}%`
  }

  window.addEventListener('resize', adjustScrollbar)
  content.addEventListener('scroll', adjustScrollbar)
  adjustScrollbar()
}
